import { Injectable } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  getDefaultControlValue,
  streetFromDictionaryValidator,
} from '@gk/gk-modules';
import { ECSControlName } from '../../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../../shared/base-new-request-form/base-new-request-form.service';
import { PINewRequestControlName } from './new-request-form.model';

@Injectable({
  providedIn: 'root',
})
export class PINewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): UntypedFormGroup {
    return this.formBuilder.group(
      {
        ...this.baseNewRequestFormService.getCommonInvestorFormGroup({
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        }).controls,
        ...this.baseNewRequestFormService.getAddressFormGroup().controls,
        [PINewRequestControlName.ObjectNameAndType]: [
          getDefaultControlValue(),
          [Validators.required],
        ],
      },
      { validator: streetFromDictionaryValidator() },
    );
  }
}
